import { Route, Routes } from 'react-router-dom';
import InterviewPage from './pages/InterviewPage';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/interview/:token" element={<InterviewPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
